module.exports = __webpack_public_path__ + "media/Images/icon-return-o-b4adf0a0db515a4fcc35552d86f69b72.svg";